import { FC, useState } from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from '@shadcn/ui/components/ui/dialog';
import { Button } from '@shadcn/ui/components/ui/button';
import { RadioGroup, RadioGroupItem } from '@shadcn/ui/components/ui/radio-group';
import { Label } from '@shadcn/ui/components/ui/label';

export const salesforceProductionLink = 'https://login.salesforce.com/';
export const salesforceSandboxLink = 'https://test.salesforce.com/';
export const salesforceLocalstorageKey = 'salesforce_environment';

interface SalesforceAuthModalProps {
    isOpen: boolean;
    onClose: () => void;
    onEnvironmentSelect: (environment: string) => void;
    oauthConfig: string;
}

export const SalesforceAuthModal: FC<SalesforceAuthModalProps> = ({
    isOpen,
    onClose,
    onEnvironmentSelect,
    oauthConfig,
}) => {
    const [environment, setEnvironment] = useState<string>('');

    const handleSubmit = () => {
        if (!environment) return;

        localStorage.setItem(salesforceLocalstorageKey, environment);
        onEnvironmentSelect(environment + oauthConfig);
    };

    const handleClose = () => {
        setEnvironment('');
        localStorage.removeItem(salesforceLocalstorageKey);
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={handleClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Connect to Salesforce</DialogTitle>
                    <DialogDescription>Choose your Salesforce environment type</DialogDescription>
                </DialogHeader>
                <div className="py-6">
                    <RadioGroup value={environment} onValueChange={setEnvironment} className="space-y-4">
                        <div className="flex items-center space-x-2">
                            <RadioGroupItem value={salesforceProductionLink} id="production" />
                            <Label htmlFor="production" className="font-medium cursor-pointer">
                                Production / Developer
                            </Label>
                        </div>
                        <div className="flex items-center space-x-2">
                            <RadioGroupItem value={salesforceSandboxLink} id="sandbox" />
                            <Label htmlFor="sandbox" className="font-medium cursor-pointer">
                                Sandbox
                            </Label>
                        </div>
                    </RadioGroup>
                </div>
                <DialogFooter className="flex-col space-y-2 sm:space-y-0 sm:flex-row sm:justify-between">
                    <Button variant="outline" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button disabled={!environment} onClick={handleSubmit} className="sm:ml-2">
                        Connect
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
